import * as styles from "./Header.module.scss";

import React, { FC, useCallback, useEffect, useState } from 'react';
import cn from "classnames"

import logo from "src/assets/images/Logo.png"
import Button from "src/components/ui/Button";
import tg_png from "src/assets/images/tg_white.png";
import tg_webp from "src/assets/images/tg_white.webp";
import { navigate } from "gatsby";

type HeaderProps = {
  fixColor?: boolean;
  withNavigateBack?: boolean;
};

const Header: FC<HeaderProps> = ({ fixColor, withNavigateBack }) => {
  const [isScroll, setIsScroll] = useState(false);
  const [invertLogo, setInvertLogo] = useState(true);

  const navigateBack = () => {
    if (withNavigateBack) navigate('/courses/ux-design#footer')
  }

  useEffect(() => {
    const osScroll = () => {

      const topWebinar = document.getElementById('record')?.getBoundingClientRect().top;
      const heightWebinar = document.getElementById('record')?.offsetHeight;
      const heightLogo = document.getElementById('logo')?.offsetHeight;
      const heightSection = document.getElementById('sectionBasics')?.offsetHeight;


      if (heightLogo && heightSection && topWebinar && heightWebinar) {
        setIsScroll(
          (!(window.scrollY < heightSection - heightLogo * 1.5) && (0 < topWebinar! - 10) || (topWebinar < -heightWebinar))
        );
      }

      if (heightLogo && heightSection) {
        setInvertLogo(window.scrollY < heightSection - heightLogo * 1.5);
      }
    };

   window.addEventListener('scroll', osScroll);

    return () => window.removeEventListener('scroll', osScroll);
  }, []);

  return (
    <div className={cn(styles.header, fixColor && styles.header_fixColor)}>
      <div className={styles.header__menu}>
        <div
          onClick={navigateBack}
          className={cn(
            styles.header__menuLogo,
            invertLogo && styles.header__menuLogo_invert,
            withNavigateBack && styles.header__menuLogo_link
          )}
        >
          <img id="logo" src={logo} alt="logo" />
        </div>
        <Button
          className={cn(styles.header__menuRecord, isScroll && styles.header__menuRecord_show)}
          id="signUp"
          element="a"
          target="_blank"
          href="https://t.me/pixel_map"
        >
          <span className={styles.header__buttonContent}>
            <picture className={styles.header__imageTg}>
              <source srcSet={tg_png} type="image/png" />
              <source srcSet={tg_webp} type="image/webp" />
              <img src={tg_png} alt="tg_png" />
            </picture>
            <div className={styles.header__buttonDescription}>Получать новости</div>
          </span>
        </Button>
      </div>
    </div>
  );
}

export default Header
